import { StoryblokComponent } from "@trydig/storyblok";
import { clsx } from "@trydig/ui";
import { cva } from "class-variance-authority";
import type { ComponentProps } from "react";
import { Container } from "@/components/ui/Container";
import type { SectionHighlightStoryblok } from "@/generated/sb/sb-types";

export interface SectionHighlightProps
  extends
    ComponentProps<"section">,
    Pick<SectionHighlightStoryblok, "items" | "fullWidth"> {
  preview: boolean;
}

const itemAspectStyles = cva("", {
  variants: {
    variant: {
      1: "aspect-3/4 md:aspect-16/9",
      2: "aspect-square md:aspect-3/2 lg:aspect-square",
      multiple: "aspect-3/2 md:aspect-16/9 lg:aspect-square",
    },
  },
});

export const SectionHighlight = ({
  items,
  fullWidth,
  className,
  preview,
  ...rest
}: SectionHighlightProps) => {
  const firstItem = items?.at(0);

  if (items?.length === 1 && firstItem && fullWidth) {
    return (
      <section
        className={clsx("py-grid-section-vertical-lg", className)}
        {...rest}
      >
        <div className="grid-cols-1 grid gap-grid-component-spacing-md">
          <StoryblokComponent
            blok={firstItem}
            preview={preview}
            className="aspect-3/4 md:aspect-16/9"
          />
        </div>
      </section>
    );
  }

  const itemsLength = items?.length || 1;

  return (
    <section {...rest}>
      <Container className={clsx("py-grid-section-vertical-lg", className)}>
        <div
          className={clsx(
            "grid gap-grid-component-spacing-md",
            itemsLength === 1 ? "grid-cols-1" : "grid-cols-1 lg:grid-cols-2",
          )}
        >
          {items?.map((item, i) => (
            <StoryblokComponent
              key={i}
              blok={item}
              preview={preview}
              className={itemAspectStyles({
                variant:
                  itemsLength === 1 ? 1 : itemsLength === 2 ? 2 : "multiple",
              })}
            />
          ))}
        </div>
      </Container>
    </section>
  );
};
